import { render } from "./PostureReportView.vue?vue&type=template&id=07b12da0&scoped=true"
import script from "./PostureReportView.vue?vue&type=script&lang=js"
export * from "./PostureReportView.vue?vue&type=script&lang=js"

import "./PostureReportView.vue?vue&type=style&index=0&id=07b12da0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b12da0"]])

export default __exports__